import { render, staticRenderFns } from "./la-faute-a-voltaire.vue?vue&type=template&id=539247da&"
import script from "./la-faute-a-voltaire.vue?vue&type=script&lang=js&"
export * from "./la-faute-a-voltaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./la-faute-a-voltaire.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports